export default __webpack_public_path__ + "static/media/videoencrypt.7fedb211.svg";